import { useEffect, useState } from "react";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useGerarDemonstrativoOcorrenciaSigat = () => {
  const [demonstrativoParams, setDemonstrativoParams] = useState({
    sqAcaoFiscal: null,
    sqProdutoAFiscal: null,
    sqPessoa: null,
    tpProduto: null,
    autoEspecial: null,
    sqItemOcorrencia: null,
    numOrdemOcorrencia: null,
    notificacao: null,
  });
  const { request: imprimeResumoRequest, data: imprimeResumoData } = useApiClient();

  useEffect(() => {
    if (demonstrativoParams?.sqAcaoFiscal) {
      const values = demonstrativoParams;
      imprimeResumoRequest(apiRoutes.fiscalizacao.ordemservico.imprimeDemonstOcorrenciaSigat, values);
    }
  }, [imprimeResumoRequest, demonstrativoParams]);

  useEffect(() => {
    let win;
    if (imprimeResumoData?.result) {
      win = window.open("", "", "height=800, width=800");
      win.document.write(imprimeResumoData.result);
      win.document.close();
      win.setTimeout(win.print, 1000);
    }
  }, [imprimeResumoData]);

  const documentoPrint = () => {};

  return { documentoPrint, setDemonstrativoParams };
};

export default useGerarDemonstrativoOcorrenciaSigat;
